import { render, staticRenderFns } from "./CredenciamentoAtualizacaoEnviarMaisBrasil.vue?vue&type=template&id=ba89dd62"
import script from "./CredenciamentoAtualizacaoEnviarMaisBrasil.vue?vue&type=script&lang=js"
export * from "./CredenciamentoAtualizacaoEnviarMaisBrasil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports